import React, { Component } from 'react';
import { Text } from '../../components';
import { Button } from '@kmx/legos-react-button';
import KBAFailureLogo from './images/kba-failure-logo';
import RequestType from '../constants/request-types';

export default class InvalidAuth extends Component {
  render() {
    const { timeOutFailure, requestType } = this.props;
    return (
      <div className='d-flex flex-col'>
        <Text.Display3>Sorry, we were not able to verify your identity</Text.Display3>
        <Text.Body1>
          You may attempt this a total of three times before having to wait 24 hours to retry. 
          Should you want to appeal your identity verification, <a href="/privacy-policy/your-data#appeal">click here</a>.        
        </Text.Body1>
        {timeOutFailure ? <div id='timeout_message'>
            <Text.Body1>You were timed out from the questionnaire.</Text.Body1>
          </div> : null}
        { requestType === RequestType.Delete ? (
          <Text.Body1>If you would like to opt out of the selling of your information or targeted advertising, <a href="/privacy-policy/opt-out">click here</a>.</Text.Body1>
        ): null}
        <div className='d-flex-center m-l'>
          <KBAFailureLogo />
        </div>
        <Button className='kmx-button--full m-t-l' disabled={false} level='primary' type='button' onClick={() => window.location.reload()}>
          Try again
        </Button>
        <Button
          className='kmx-button--full m-t-s'
          disabled={false}
          style='secondary'
          type='button'
          onClick={() => (window.location.href = '/privacy-policy')}>
          Cancel
        </Button>
      </div>
    );
  }
}
